module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row portfolio-row"
  }, [_c('router-view', {
    attrs: {
      "visible": true
    },
    on: {
      "hide": _vm.hideModal
    }
  }, [_c('div', {
    staticClass: "project-modal"
  }, [_c('h2', {
    staticClass: "subject"
  }, [_c('b', [_vm._v("Subject: ")]), _vm._v(_vm._s(_vm.routeProject.title))]), _c('p', {
    staticClass: "desc"
  }, [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(_vm.routeProject.description))]), _c('p', {
    staticClass: "link"
  }, [_c('b', [_vm._v("Link:")]), _c('a', {
    attrs: {
      "href": _vm.routeProject.link || 'javascript:void(0)',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.routeProject.link || 'unavailiable'))])]), _c('div', {
    staticClass: "tech-area"
  }, [_c('h3', {
    staticClass: "tech-title"
  }, [_c('b', [_vm._v("Technologies Used:")])]), _c('ul', {
    staticClass: "tech-list"
  }, _vm._l((_vm.routeProject.stack), function(str) {
    return _c('li', [_vm._v(_vm._s(str))])
  }))]), _c('div', {
    staticClass: "image-area"
  }, [_c('h3', {
    staticClass: "image-title"
  }, [_vm._v("Image:")]), _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.routeProject.image
    }
  })])])]), _c('div', {
    staticClass: "col-xs-12 nav-row"
  }, [_c('nav', [_c('router-link', {
    staticClass: "nav-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("McCall Alexander")])], 1)]), _vm._m(0), _c('div', {
    staticClass: "col-xs-12 search-bg"
  }, [_c('multiselect', {
    key: "909090909",
    staticClass: "multiselect",
    attrs: {
      "options": _vm.selectOptions,
      "multiple": true,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": true,
      "placeholder": "Search something!☟",
      "show-labels": false
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  })], 1), _c('div', {
    staticClass: "col-xs-12 projects-bg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "projects col-xs-10 col-xs-offset-1"
  }, [_c('transition-group', {
    staticClass: "projects-list",
    attrs: {
      "name": "fade",
      "appear": "appear"
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('div', {
      key: index,
      staticClass: "project-item"
    }, [_c('project', {
      key: index,
      attrs: {
        "index": index,
        "project": project
      }
    })], 1)
  }))], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 header-col"
  }, [_c('h1', [_vm._v("Portfolio")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2b71452"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portfolio.vue
// module id = 376
// module chunks = 1